import { TbArrowLeft } from "react-icons/tb";
import CarePlusStepper from "./CarePlusStepper";

type Step = "treatment" | "plan" | "checkout";

interface Props {
  /** Treatment V3 goes back to the questionnaire; Plan V3 swaps back to Treatment in place. */
  onBack: () => void;
  t: (key: string, fallback: string) => string;
  current?: Step;
  backId?: string;
}
const CarePlusHeaderBar = ({ onBack, t, current = "treatment", backId }: Props) => (
  <div className="absolute inset-x-[6px] top-[12px] z-10 flex items-center">
    <button
      id={backId}
      type="button"
      aria-label={t("back", "Back")}
      onClick={onBack}
      className="flex size-[44px] shrink-0 cursor-pointer items-center justify-center border-0 bg-transparent p-0"
    >
      <TbArrowLeft size={22} className="text-white" />
    </button>
    <div className="min-w-0 flex-1 px-[8px]">
      <CarePlusStepper current={current} t={t} compact variant="white" />
    </div>
    <div className="size-[44px] shrink-0" aria-hidden="true" />
  </div>
);

export default CarePlusHeaderBar;
